import {
  V2MicrogridOverviewGetBsaTodayInfoPostResponse,
  V2MicrogridOverviewGetNewEnergyExistsPostResponse,
  V2MicrogridOverviewGetNewEnergyRatePostResponse,
} from '@maxtropy/intelligent-dispath-apis-v2';
import React, { FC, useContext, useState } from 'react';
import DataBox from '../DataBox';
import styles from './index.module.scss';
import icon_electricSupply from '../../../../../imgs/icon-electricSupply.png';
import icon_load from '../../../../../imgs/icon-load.png';
import icon_small_ground from '../../../../../imgs/icon-small-ground.png';
import icon_energyStorage from '../../../../../imgs/icon-energyStorage.png';
import {
  formatPower,
  judgeOverZero,
  keepTwoAbsOrLine,
  keepTwoOrLine,
  keepTwoOrLineAbs,
} from '@/pages/IndustrialGreenMicBigScreen/utils';
import icon_pv from '../../../../../imgs/icon-PV.png';
import icon_windTurbine from '../../../../../imgs/icon-windTurbine.png';
import BsaDataBox from '../BsaDataBox';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';

export interface IFiveAssetsRender {
  dataExit?: V2MicrogridOverviewGetNewEnergyExistsPostResponse;
  data?: V2MicrogridOverviewGetNewEnergyRatePostResponse;
}

const FiveAssetsRender: FC<IFiveAssetsRender> = props => {
  const { dataExit, data } = props;
  const { isFullScreen } = useContext(ShareDataContext);
  const [bsaData, setBsaData] = useState<V2MicrogridOverviewGetBsaTodayInfoPostResponse>();

  return (
    <>
      {/* 光伏 */}
      <DataBox
        top={12}
        left={5}
        leftTitle={'源'}
        data={[
          {
            label: '光伏容量',
            value: keepTwoOrLine(data?.pvInfo?.capacity),
            unit: 'kW',
            color: 'rgba(255,255,255,0.85)',
          },
          {
            label: '今日发电量',
            value: formatPower(data?.pvInfo?.todayGeneration).value,
            unit: formatPower(data?.pvInfo?.todayGeneration).unit,
            color: '#16DD8E',
          },
        ]}
      />
      {/* 图片 */}
      <div className={`${styles.element1} ${styles.element}`} style={{ top: isFullScreen ? '20%' : '16%' }}>
        <img className={styles.img_obj_sty} src={icon_pv} alt="" />
        <img className={styles.img_normal_sty} src={icon_small_ground} alt="" />
        <div className={styles.label}>{'光伏'}</div>
      </div>
      {/* 流动的线1 */}
      <div className={`${styles.lineBg1} ${styles.lineBg_normal}`}>
        {/* 线上面数据 */}
        <div className={styles.line_data}>
          <div className={styles.label}>发电功率：</div>
          <div className={styles.value}>{keepTwoOrLine(data?.pvInfo?.generationPower)}kW</div>
        </div>
        <div className={`${styles.line_inside_normal} ${styles.line1} ${styles.flow_left}`}></div>
      </div>

      {/* 风电 */}
      <DataBox
        top={12}
        left={75}
        leftTitle={'源'}
        data={[
          {
            label: '风电站容量',
            value: keepTwoOrLine(data?.wpInfo?.capacity),
            unit: 'kW',
            color: 'rgba(255,255,255,0.85)',
          },
          {
            label: '今日发电量',
            value: formatPower(data?.wpInfo?.todayGeneration).value,
            unit: formatPower(data?.wpInfo?.todayGeneration).unit,
            color: '#16DD8E',
          },
        ]}
      />
      <div className={`${styles.element2} ${styles.element}`} style={{ top: isFullScreen ? '20%' : '16%' }}>
        <img className={styles.img_obj_sty} src={icon_windTurbine} alt="" />
        <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
        <div className={styles.label}>{'风电'}</div>
      </div>
      {/* 流动的线2 */}
      <div className={`${styles.lineBg2} ${styles.lineBg_normal}`}>
        {/* 线上面数据 */}
        <div className={styles.line_data}>
          <div className={styles.label}>发电功率：</div>
          <div className={styles.value}>
            {keepTwoOrLine(data?.wpInfo?.generationPower)}
            kW
          </div>
        </div>
        <div className={`${styles.line_inside_normal} ${styles.line2} ${styles.flow_right}`}></div>
      </div>

      {/* 市电 */}
      <DataBox
        top={82}
        left={5}
        leftTitle={'网'}
        data={[
          {
            label: '今日上网电量',
            value: formatPower(data?.gridInfo?.feedIn).value,
            unit: formatPower(data?.gridInfo?.feedIn).unit,
            color: '#16DD8E',
          },
          {
            label: '今日下网电量',
            value: formatPower(data?.gridInfo?.purchased).value,
            unit: formatPower(data?.gridInfo?.purchased).unit,
            color: '#00ADFF',
          },
        ]}
      />
      {/* 图片 */}
      <div className={`${styles.element3} ${styles.element}`}>
        <img className={styles.img_obj_sty} src={icon_electricSupply} alt="" />
        <img className={styles.img_normal_sty} src={icon_small_ground} alt="" />
        <div className={styles.label}>{'市电'}</div>
      </div>
      {/* 流动的线3 */}
      <div className={`${styles.lineBg3} ${styles.lineBg_normal}`}>
        {/* 线上面数据 */}
        <div className={styles.line_data}>
          <div className={styles.label}>{judgeOverZero(data?.gridInfo?.power) ? '净下网' : '上网'}功率:</div>
          <div className={styles.value}>{keepTwoOrLineAbs(data?.gridInfo?.power)}kW</div>
        </div>
        <div
          className={`${styles.line_inside_normal} ${styles.line3} ${
            styles[judgeOverZero(data?.gridInfo?.power) ? 'flow_left' : 'flow_right']
          }`}
        ></div>
      </div>

      {/* 负载 */}
      <DataBox
        top={80}
        left={76}
        leftTitle={'荷'}
        data={[
          {
            label: '今日用电量',
            value: formatPower(data?.loadInfo?.todayConsumption).value,
            unit: formatPower(data?.loadInfo?.todayConsumption).unit,
            color: '#16DD8E',
          },
        ]}
      />
      <div className={`${styles.element4} ${styles.element}`}>
        <img className={styles.img_obj_sty} src={icon_load} alt="" />
        <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
        <div className={styles.label}>{'负载'}</div>
      </div>
      {/* 流动的线4 */}
      <div className={`${styles.lineBg4} ${styles.lineBg_normal}`}>
        {/* 线上面数据 */}
        <div className={styles.line_data}>
          <div className={styles.label}>用电负荷:</div>
          <div className={styles.value}>{keepTwoOrLine(data?.loadInfo?.powerDemand)}kW</div>
        </div>
        <div className={`${styles.line_inside_normal} ${styles.line4} ${styles.flow_left}`}></div>
      </div>

      {/* 储能 */}
      <BsaDataBox dataExit={dataExit} top={86} left={62} leftTitle="储" getBsaData={val => setBsaData(val)} />
      <div className={`${styles.element5} ${styles.element}`}>
        <div className={styles.power_box}>
          <div className={styles.power_label}>{judgeOverZero(bsaData?.power) ? '充电' : '放电'}功率：</div>
          <div className={styles.power_value}>{keepTwoAbsOrLine(bsaData?.power)}kW</div>
        </div>
        <img className={styles.img_obj_sty} src={icon_energyStorage} alt="" />
        <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
        <div className={styles.label}>储能</div>
      </div>
      {/* 流动的线5 */}
      <div className={`${styles.lineBg5} ${styles.lineBg_normal}`}>
        <div
          className={`${styles.line_inside_normal} ${styles.line5} ${
            styles[judgeOverZero(bsaData?.power) ? 'flow_down' : 'flow_up']
          }`}
        ></div>
      </div>
    </>
  );
};

export default FiveAssetsRender;
